import * as nodeUtils from "./utils/nodeUtils";
import * as pathUtils from "./utils/pathUtils";

export const getNodeById = (model, id) => {

  if (!id) {
    return {};
  }

  try {
    const node = getNodeByIdLogic(model, id);
    return { data: node[0], index: node[1] };
  } catch (e) {
    return { data: undefined, index: undefined, error: e };
  }
};

export const getNodeByUuid = (model, uuid) => {
  if (!uuid) {
    return {};
  }

  const _candidate = [];

  nodeUtils.visitElements(model, (e) => {
    if (nodeUtils.getUUID(e) === uuid) {
      _candidate.push(e);
    }
  });

  if (_candidate.length === 0) {
    return {};
  }
  return { data: _candidate[0] };
};

export const getNodeWithTraversalById = (model, id) => {
  let element = getNodeByIdLogic(model, id);
  let target = nodeUtils.getIdTarget(element[0]);

  while (target) {
    element = getNodeByIdLogic(model, target);
    target = nodeUtils.getIdTarget(element[0]);
  }

  return { data: element[0], index: element[1] };
};

//------------------------------------------------------------------------

const getNodeByIdLogic = (model, id) => {
  let candidate = [model, 0];

  const path = pathUtils.getIdPath(id);

  if (path.length === 1) {
    if (path[0] === pathUtils.getIdMarkerRoot()) {

      candidate = getNodeRoot(candidate);
    }
  }

  for (let i = 1; i < path.length; i++) {
    if (path[i] === pathUtils.getIdMarkerRoot()) {
      
      candidate = getNodeRoot(candidate);
      continue;
    }

    if (path[i] === pathUtils.getIdMarkerFunction()) {
      candidate = getNodeFunction(candidate, path, i++);
      continue;
    }
    if (path[i] === pathUtils.getIdMarkerCondition()) {
      candidate = getNodeLogic(candidate, path, i);
      continue;
    }
    if (path[i] === pathUtils.getIdMarkerParameter()) {
      candidate = getNodeParameter(candidate, path, ++i);
      continue;
    }
    if (path[i] === pathUtils.getIdMarkerChoice()) {
      candidate = getNodeChoice(candidate, path, ++i);
      continue;
    }
  }

  if (nodeUtils.getID(candidate[0]) !== id) {
    return [null, 0];
  }

  return candidate;
};

const getNodeRoot = (element) => {
  return [element[0], 0]
}

const getNodeFunction = (element, path, i) => {
  const name = path[i + 1];
  const functions = nodeUtils.getFunctions(element[0]);

  for (let j = 0; j < functions.length; j++) {
    const nameElement = nodeUtils.getName(functions[j]);

    if (nameElement === name) {
      return [functions[j], j];
    }
  }

  throw new Error(`The function '${name}' does not exist!`);
};

const getNodeLogic = (element, path, i) => {
  const name = path[i + 1];
  const logic = nodeUtils.getConditions(element[0]);

  for (let j = 0; j < logic.length; j++) {
    const nameElement = nodeUtils.getName(logic[j]);

    if (nameElement === name) {
      return [logic[j], j];
    }
  }

  throw new Error(`The expression '${name}' does not exist!`);
};

const getNodeParameter = (element, path, i) => {
  const name = path[i];
  const parameters = nodeUtils.getParameters(element[0]);

  for (let j = 0; j < parameters.length; j++) {
    const nameElement = nodeUtils.getName(parameters[j]);

    if (nameElement === name) {
      return [parameters[j], j];
    }
  }

  throw new Error(`The parameter '${name}' does not exist!`);
};

const getNodeChoice = (element, path, i) => {
  const name = path[i];
  const choices = nodeUtils.getChoices(element[0]);

  for (let j = 0; j < choices.length; j++) {
    const nameElement = nodeUtils.getName(choices[j]);

    if (nameElement === path[i]) {
      return [choices[j], j];
    }
  }

  throw new Error(`The choice '${name}' does not exist!`);
};
